import Api from '@/api/api.js'
import configApi from '@/api/config/_api_config'

export default {
    async resume(params) {
        const access = await configApi().post('/admin/medical-dashboard-access', {}, {
            timeout: 20000, admin_dashboard_scoped: true
        })
        const token = access && access.data && access.data.data && access.data.data.access_token
        if (!token) throw new Error('Accès administrateur indisponible.')
        const response = await Api().get('/v1/clinical-analytics/dashboard-summary', {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Admin-Medical-Access': token }, params
        })
        return response.data
    }
}
